module.exports = __webpack_public_path__ + "static/waiter-app-b13ee4e6c71491e02be5dee3525967d2.mp4";